import FormattedMessage from 'I18n/components/FormattedMessage';
import { useMediaQuery } from 'academy-common-lib/utils/Styling';
import { SCREENS, SUB_SCREENS } from '../../../constants/Tracking';
import UsageTracker from '../../../utils/UsageTracker';
import { useEffect } from 'react';
import { View } from 'foundations-components/components/View';
import { RankedRecommendationsWithNegativeFeedback } from '../../recommendations/components/RankedRecommendationsWithNegativeFeedback';
import { NavMarker } from 'react-rhumb';
import { jsx as _jsx } from "react/jsx-runtime";
export const TrackRecommendationsPage = ({
  id
}) => {
  const {
    isLaptop
  } = useMediaQuery();
  useEffect(() => {
    UsageTracker.trackStandalone('Pageview', {
      screen: SCREENS.TRACK,
      subscreen: SUB_SCREENS.RECOMMENDATIONS,
      trackId: id
    });
  }, [id]);
  const handleOnItemClick = (item, index) => {
    UsageTracker.trackStandalone('Learning Center Interaction', {
      action: 'track-end-recommendation-card-click',
      cardNumber: index + 1,
      trackId: id,
      recommendationType: 'ranked'
    });
  };
  return /*#__PURE__*/_jsx(NavMarker, {
    name: "TRACK_RECOMMENDATIONS_LOADED",
    children: /*#__PURE__*/_jsx(View, {
      "data-test-id": "track-recommendations-page",
      padding: "700",
      children: /*#__PURE__*/_jsx(RankedRecommendationsWithNegativeFeedback, {
        appearsIn: "course-recommendations",
        description: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "learningCenter.tracks.recommendations.courseRecommendations.body"
        }),
        direction: isLaptop ? 'column' : 'row',
        header: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "learningCenter.tracks.recommendations.courseRecommendations.heading"
        }),
        inferenceSource: "COURSE_RECOMMENDATIONS",
        onItemClick: handleOnItemClick,
        resultTypes: ['TRACK', 'LESSON'],
        size: isLaptop ? 'small' : 'large'
      })
    })
  });
};